import React from 'react';
import ReactDOM from 'react-dom'; // React 16 style
import './index.css';
import './styles/tailwind.css'; // Tailwind CSS for remote components
import App from './App';
import * as serviceWorker from './serviceWorker';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './auth/msal.instance';
import { completeMicrosoftLogin } from './auth/auth.service';
import { initSharedStoreTokenSync } from './utils/syncSharedStoreToken';

const initApp = async () => {
  let microsoftAuthError = null;

  await initSharedStoreTokenSync();

  try {
    // handleRedirectPromise returns null if there's no redirect in progress,
    // so it's safe to call it on every app load - it's optimized internally
    const redirectResponse = await msalInstance.handleRedirectPromise();

    // Only if there's a redirect response, complete the Microsoft login
    if (redirectResponse) {
      msalInstance.setActiveAccount(redirectResponse.account);
      const res = await completeMicrosoftLogin();
      if (!res?.ok) {
        microsoftAuthError = res;
      }
    }
  } catch (e) {
    microsoftAuthError = {
      ok: false,
      reason: 'HANDLE_REDIRECT_FAILED',
      error: e,
    };
  }

  ReactDOM.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App microsoftAuthError={microsoftAuthError} />
      </MsalProvider>
    </React.StrictMode>,
    document.getElementById('root'),
  );
};

initApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
